//src/types/Store/Aircraft/Prop.ts

import { MaintData } from '@/types/Store/Aircraft/Maintenance'

export interface Propeller extends MaintData {
  poh: number
  fixedPitch?: boolean
}

export function createPropeller(init: Partial<Propeller> = {}): Propeller {
  return {
    model: '',
    serial: '',
    poh: 0, //Propeller's own hour-meter reading at the time of its last major overhaul
    mfr: '',
    year: 1800,
    installDate: new Date(),
    installTach: 0, //the engine/prop's own hour-meter reading at the moment it was installed
    acInstallTach: 0, //the aircraft's tach reading at the moment this engine/prop was installed on it.
    fixedPitch: true,
    ...init
  }
}

export interface Hub extends MaintData {
  Huboh: number
}

export function createHub(init: Partial<Hub> = {}): Hub {
  return {
    model: '',
    serial: '',
    Huboh: 0,
    mfr: '',
    year: 1800,
    installDate: new Date(),
    installTach: 0,
    acInstallTach: 0,
    ...init
  }
}
